/// <reference path="../types.d.ts" />
import history from '../history';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../core/net';
import { showFeedback } from './ui';
import { Group } from './action-types';
import { HttpMethods } from '@codametrix/ui-common';
const chooseGroup = createAction(Group.CHOOSE_GROUP);
const listEligibleGroupMembers = createAction(Group.LIST_GROUP_MEMBERS);
const listItems = createAsyncThunk(Group.LIST, async (params)=>{
    const pageableList = await api({
        endpoint: `/users/groups/tenant/v1?&tenantId=${params.id}`,
        init: {
            method: HttpMethods.GET
        }
    });
    return pageableList;
});
const dispatchGetGroupMemberInfo = async (dispatch, group)=>{
    const groupId = group.id;
    const eligibleMembers = await api({
        endpoint: `/users/groups/${groupId}/users/v1?eligibleMembers=true`,
        init: {
            method: HttpMethods.GET
        }
    });
    dispatch(listEligibleGroupMembers(eligibleMembers));
};
const getGroupDetail = createAsyncThunk(Group.FETCH_DETAIL, async (params, { dispatch })=>{
    const { data: group, path } = params;
    const id = group.id;
    if (id === undefined || id === null) {
        return {};
    }
    const detail = await api({
        endpoint: `/users/groups/${id}/users/v1`
    });
    dispatch(chooseGroup(group));
    history.push(path);
    dispatchGetGroupMemberInfo(dispatch, group);
    return detail;
});
const addGroupMember = createAsyncThunk(Group.ADD_GROUP_USER, async (params, _thunkAPI)=>{
    const { groupId, groupMembers } = params;
    const saved = await api({
        endpoint: `/users/groups/${groupId}/users/v1`,
        init: {
            method: HttpMethods.POST
        },
        body: groupMembers
    });
    return saved;
});
const saveGroup = createAsyncThunk(Group.SAVE, async (group, { dispatch })=>{
    group = {
        ...group,
        active: true
    };
    // Updating group not supported on backend yet
    const isUpdate = group.id != null;
    let method = isUpdate ? HttpMethods.PUT : HttpMethods.POST;
    let endpoint = isUpdate ? `/users/groups/${group.id}/v1` : `/users/groups/v1`;
    await api({
        endpoint,
        init: {
            method
        },
        body: group
    });
    dispatch(showFeedback({
        id: Date.now(),
        message: `Group Saved.`,
        dismissable: true,
        className: 'feedback-working'
    }));
    history.goBack();
});
const deleteGroup = createAsyncThunk(Group.DELETE, async (groupId, { dispatch })=>{
    const group = {
        id: groupId
    };
    let method = HttpMethods.DELETE;
    await api({
        endpoint: `/users/groups/${groupId}/v1`,
        init: {
            method
        },
        body: group
    });
    dispatch(showFeedback({
        id: Date.now(),
        message: `Group Deleted.`,
        dismissable: true,
        className: 'feedback-working'
    }));
    history.goBack();
});
export const groupActions = {
    chooseGroup,
    listItems,
    getGroupDetail,
    saveGroup,
    deleteGroup,
    listEligibleGroupMembers,
    addGroupMember
};
